import {Form, Modal} from "react-bootstrap";
import {useEffect, useState} from "react";
import {listService} from "../../services/listsService";
import {useForm} from "react-hook-form";
import FormSelectCustom from "../../shared/components/FormSelectCustom";
import {customerService} from "../../services/customerService";
import ConfirmationModal from "../ConfirmationModal";

export interface TruckInfo {
    arrivalTime: string;
    arrivalDate: string;
    jobTruckId: number,
    truckNumber: string,
    arrivalTimeWindowId: string,
    arrivalDateAndTime: string
}
interface NewEditTruckModalProps {
    show: boolean;
    toggle: () => void;
    truck: TruckInfo;
    refreshData: () => void;
    customerId: number,
    jobId: number,
}
const NewEditTruckModal: React.FC<NewEditTruckModalProps> = ({ show, toggle, truck, refreshData, customerId, jobId}) => {
    const [arrivalTimes, setArrivalTimes] = useState([])
    const { register, reset, getValues, watch, formState: { dirtyFields, errors } } = useForm();
    const [showErrors, setShowErrors] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    useEffect(() => {
        listService.getArrivalTimes().then(r => {
            setArrivalTimes(r);
        })
    }, []);
    useEffect(() => {
        if(!truck) return;
        const dt = new Date(truck.arrivalDateAndTime);

        const yyyy = dt.getFullYear();
        const MM   = String(dt.getMonth() + 1).padStart(2, "0");
        const dd   = String(dt.getDate()).padStart(2, "0");

        const hh   = String(dt.getHours()).padStart(2, "0");
        const mm   = String(dt.getMinutes()).padStart(2, "0");

        truck.arrivalDate = `${yyyy}-${MM}-${dd}`;
        truck.arrivalTime = `${hh}:${mm}`;
        reset(truck)
    }, [truck]);

    const handleSave = () => {
        const data = getValues()
        const [year, month, day]   = data.arrivalDate.split("-").map(Number);
        const [hour, minute]       = data.arrivalTime.split(":").map(Number);
        const arrivalDateTime = new Date(year, month - 1, day, hour, minute);
        data.arrivalDateAndTime = arrivalDateTime.toISOString();
        customerService.saveTruck(customerId, jobId, data).then(r => {refreshData(); toggle();});
    };
    const deleteTruck = () => {
        const data = getValues()
        customerService.deleteTruck(customerId, jobId, data).then(r => {refreshData(); toggle();});
    };
    return (
        <>
            <Modal show={show} onHide={toggle} className="fade modal-lg" id="truckModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1}
                 aria-labelledby="truckModal" aria-hidden="true">
                <Modal.Header className="modal-header">
                    <h5 className="modal-title" id="truckModalTitle">Truck</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close" onClick={toggle}></button>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    <Form>
                        <div className="row g-2">
                            <div className="col">
                                <div className="serviceInputTable">
                                    <table className="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <label className="form-label">Truck #</label>
                                                <div className="cuteInput input-group input-group-sm">
                                                    <span className="input-group-text" id="fancy"><i className="fa-regular fa-truck"></i></span>
                                                    <input {...register("truckNumber")} type="text" className="form-control" placeholder="Truck #" aria-label="fancy" aria-describedby="fancy"/>
                                                </div>
                                            </td>
                                            <td>
                                                <FormSelectCustom
                                                    label="Arrival"
                                                    name="arrivalTimeWindowId"
                                                    register={register}
                                                    options={arrivalTimes}
                                                />
                                            </td>
                                            <td>
                                                <label htmlFor="textInput" className="form-label">Date</label>
                                                <input {...register("arrivalDate")} type="date" className="form-control form-control-sm" id="textInput" aria-describedby="textInput" placeholder="text"/>
                                            </td>
                                            <td>
                                                <label htmlFor="textInput" className="form-label">Time</label>
                                                <input {...register("arrivalTime")} type="time" className="form-control form-control-sm" id="textInput" aria-describedby="textInput" placeholder="text"/>
                                            </td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {truck && <span className="flex-fill"><a style={{cursor: 'pointer'}} onClick={() => {
                        toggle();
                        setOpenConfirmationModal(true)
                    }} className="text-danger"
                                                             data-bs-target="#forRealModal"
                                                             data-bs-toggle="modal">remove</a></span>}
                    <button onClick={handleSave} type="submit" className="btn btn-primary text-strong text-uppercase m-100">Save
                    </button>
                    <button onClick={toggle} type="button" className="btn btn-cancel text-strong text-uppercase m-100"
                            data-bs-dismiss="modal">Cancel
                    </button>
                </Modal.Footer>
            </Modal>
            <ConfirmationModal show={openConfirmationModal} toggle={() => setOpenConfirmationModal(false)} onConfirm={deleteTruck}/>
        </>
    );
}
export default NewEditTruckModal;